import { INavContent, ISubCategory } from '@garmin/components-global-web/dist/types/components/vertical-nav/interfaces';
import { Scope } from '@garmin-avcloud/avcloud-fly-web-common/admin-authorization';
import { FeatureFlyAdmin } from '@garmin-avcloud/avcloud-fly-web-common/shared';

export interface AuthISubcategory extends ISubCategory {
  scopes?: Scope[];
  requireAllScopes?: boolean;
  featureFlag?: FeatureFlyAdmin;
}

export interface AuthINavContent extends INavContent {
  scopes?: Scope[];
  requireAllScopes?: boolean;
  featureFlag?: FeatureFlyAdmin;
  subcategories: AuthISubcategory[];
}

export const NAVIGATION_TREE: AuthINavContent[] = [
  {
    id: 0,
    isOpen: false,
    isActive: false,
    linkUrl: '',
    categoryLabel: 'Aircraft',
    categoryIcon: '',
    subcategories: [
      {
        id: 0,
        linkUrl: `/aircraft/aircraft-search`,
        isActive: false,
        subCategoryLabel: 'Aircraft Search'
      },
      {
        id: 1,
        linkUrl: `/aircraft-logbook/upload`,
        featureFlag: FeatureFlyAdmin.ENABLE_AIRCRAFT_LOGBOOK_UPLOAD,
        isActive: false,
        subCategoryLabel: 'Upload and Decrypt Logs'
      }
    ]
  },
  {
    id: 1,
    isOpen: false,
    isActive: false,
    linkUrl: '',
    categoryLabel: 'Aircraft Library',
    categoryIcon: '',
    subcategories: [
      {
        id: 0,
        linkUrl: `/aircraft-library/aircraft-makes`,
        isActive: false,
        subCategoryLabel: 'Aircraft Makes'
      },
      {
        id: 1,
        linkUrl: `/aircraft-library/aircraft-models`,
        isActive: false,
        subCategoryLabel: 'Aircraft Models'
      }
    ]
  },
  {
    id: 2,
    isOpen: false,
    isActive: false,
    linkUrl: '',
    categoryLabel: 'Users',
    categoryIcon: '',
    subcategories: [
      {
        id: 0,
        linkUrl: `/users/search`,
        isActive: false,
        subCategoryLabel: 'User Search',
        scopes: [Scope.USER_EMAIL_SEARCH, Scope.USER_CUSTOMER_GUID_SEARCH],
        requireAllScopes: false
      }
    ]
  },
  {
    id: 3,
    isOpen: false,
    isActive: false,
    linkUrl: '',
    categoryLabel: 'Organizations',
    categoryIcon: '',
    subcategories: [
      {
        id: 0,
        linkUrl: `/orgs/create`,
        isActive: false,
        subCategoryLabel: 'Organization Create',
        scopes: [Scope.ORGS_ROLES_ORGANIZATION_CREATE]
      },
      {
        id: 1,
        linkUrl: `/orgs/search`,
        isActive: false,
        subCategoryLabel: 'Organization Search',
        scopes: [Scope.ORGS_ROLES_ORGANIZATION_SEARCH]
      }
    ]
  }
];
